// extracted by mini-css-extract-plugin
export default {"info_bgr":"InformationBlock_info_bgr__F0CWZ","text_wrapper":"InformationBlock_text_wrapper__KiMvQ","info_img":"InformationBlock_info_img__ja6s+"};